module.exports = __webpack_public_path__ + "img/Manual-de-Formatos.8f448015.svg";